export default __webpack_public_path__ + "static/pay_success-ff7b133796ae9ec4af1eef8be5f912ae.png";